/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MeetingInputs */

const cs_enum_meeting = /** @type {(inputs: Enum_MeetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schůzka`)
};

const en_enum_meeting = /** @type {(inputs: Enum_MeetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting`)
};

/**
* | output |
* | --- |
* | "Meeting" |
*
* @param {Enum_MeetingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_meeting = /** @type {((inputs?: Enum_MeetingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MeetingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_meeting(inputs)
	return cs_enum_meeting(inputs)
});